import { Fragment, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, BACKEND_URL, errMsg } from "../../lib/api";
import { StatusSelect, fmtDate } from "./shared";

const STATUSES = ["new", "quoted", "accepted", "declined", "completed"];

function RequestCard({ r, onSave }) {
  const [notes, setNotes] = useState(r.owner_notes || "");
  const rows = [["Event date", r.event_date], ["Treat", r.treat_type], ["Quantity", r.quantity], ["Letters to spell", r.letters_to_spell], ["Colors / theme", r.theme], ["Budget", r.budget]];
  return (
    <div className="panel p-5" data-testid={`request-row-${r.id}`}>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <p className="font-display text-xl">{r.name}</p>
          <p className="text-sm text-white/60">{r.email} · {r.phone} · {fmtDate(r.created_at)}</p>
        </div>
        <StatusSelect value={r.status} options={STATUSES} onChange={(v) => onSave(r.id, { status: v })} testid={`request-status-select-${r.id}`} />
      </div>
      <div className="mt-4 grid gap-5 md:grid-cols-[1fr_1fr_160px]">
        <dl className="grid grid-cols-2 gap-x-4 gap-y-1 text-sm">
          {rows.map(([k, v]) => (<Fragment key={k}><dt className="text-white/50">{k}</dt><dd className="text-white/85">{v || "—"}</dd></Fragment>))}
          {r.notes && <p className="col-span-2 mt-2 rounded-xl bg-white/5 p-2 text-white/75">{r.notes}</p>}
        </dl>
        <div className="space-y-2">
          <textarea rows={3} className="field text-sm" placeholder="Private notes (only you see these)" value={notes} onChange={(e) => setNotes(e.target.value)} data-testid={`request-notes-input-${r.id}`} />
          <button className="btn-royal !px-4 !py-2 text-sm" onClick={() => onSave(r.id, { notes })} data-testid={`request-save-notes-${r.id}`}>Save notes</button>
        </div>
        {r.photo_path ? (
          <a href={`${BACKEND_URL}/api/files/${r.photo_path}`} target="_blank" rel="noreferrer" data-testid={`request-photo-${r.id}`}>
            <img src={`${BACKEND_URL}/api/files/${r.photo_path}`} alt="Inspiration" className="h-40 w-full rounded-2xl object-cover" />
          </a>
        ) : <p className="text-sm text-white/40">No photo</p>}
      </div>
    </div>
  );
}

export default function AdminRequests() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/admin/custom-requests").then((r) => setItems(r.data)); }, []);

  const save = async (id, patch) => {
    try {
      const { data } = await api.patch(`/admin/custom-requests/${id}`, patch);
      setItems((xs) => xs.map((x) => (x.id === id ? data : x)));
      toast.success("Request updated");
    } catch (e) { toast.error(errMsg(e)); }
  };

  if (!items) return <p className="text-white/60">Loading requests...</p>;
  if (!items.length) return <p className="panel p-8 text-center text-white/60" data-testid="requests-empty">No custom requests yet.</p>;
  return <div className="space-y-4" data-testid="admin-requests">{items.map((r) => <RequestCard key={r.id} r={r} onSave={save} />)}</div>;
}
